import {
  buildCreateSchoolWithPropsCreatePath,
  buildSchoolDetailsSchoolPropertiesListPath,
  buildSchoolGetCategoriesListPath,
  buildSchoolHandleStatusesCreatePath,
  buildSchoolInviteToAcceptListPath,
} from '../../generated/schooly-api-v1';

// Paths (aliased builders for convenient imports)
export const schoolPropertiesListPath = buildSchoolDetailsSchoolPropertiesListPath;
export const schoolCategoriesListPath = buildSchoolGetCategoriesListPath;
export const schoolStatusesCreatePath = buildSchoolHandleStatusesCreatePath;
export const schoolCreateWithPropertiesPath = buildCreateSchoolWithPropsCreatePath;
export const schoolInviteToAcceptListPath = buildSchoolInviteToAcceptListPath;
